import { render } from "./EditModal.vue?vue&type=template&id=6e8b9b12"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"
script.render = render

export default script